import { DataGrid, GridToolbarQuickFilter, esES } from '@mui/x-data-grid';
import { GRAY_VERY_LIGHT, GREEN_LIGHT } from '../../../assets/Styles';
import { Box } from '@mui/material';
import './index.css'


export default function DataTable(props: any) {
  const { columns, rows, handleDoubleClick, loading, keyname = '' } = props

  const TEXT_COLOR = '#f9fdfe';
  const BKG_COLOR = '#45a749';

  function QuickSearchToolbar() {
    return (
      <Box
        sx={{
          paddingBottom: '10px',
          display: 'flex',
          width: 'fit-content',
          alignItems: 'center',
        }}
      >
        <GridToolbarQuickFilter
          sx={{
            padding: '5px', minWidth: '300px', fontStyle: 'italic',
            fontFamily: 'Poppins'
          }}
          placeholder='Filtro rápido' debounceMs={300} />
      </Box>
    );
  }

  return (
    <DataGrid autoHeight localeText={esES.components.MuiDataGrid.defaultProps.localeText}
      sx={{
        '&.MuiDataGrid-root': {
          border: 'none'
        },
        '.MuiDataGrid-main': {
          backgroundColor: 'transparent'
        },

        '.MuiDataGrid-columnSeparator': {
          display: 'none',
        },
        '.MuiDataGrid-columnHeaders': {
          color: TEXT_COLOR,
          backgroundColor: BKG_COLOR,
        },
        '.MuiDataGrid-columnHeader:focus': {
          outline: 'none'
        },
        '.MuiDataGrid-sortIcon': {
          color: TEXT_COLOR,
        },
        '.MuiDataGrid-menuIconButton': {
          color: TEXT_COLOR,
        },
        '.MuiDataGrid-menuList': {
          color: GREEN_LIGHT,
        },
        '.MuiDataGrid-row': {
          backgroundColor: 'transparent',
          '&:hover, &.Mui-hovered': {
            backgroundColor: '#ACD1AFB0',
          },
        },
        '.MuiDataGrid-cell': {
          color: 'black'
        },
        '.MuiDataGrid-cell:focus-within': {
          outline: 'none'
        }
      }}
      onCellDoubleClick={(event: any) => handleDoubleClick(event)}
      rows={rows}
      columns={columns}
      initialState={{
        pagination: {
          paginationModel: { page: 0, pageSize: 10 },
        },
      }}
      slots={{ toolbar: QuickSearchToolbar }}
      pageSizeOptions={[5, 10]}
      checkboxSelection={false}
      disableRowSelectionOnClick={true}
      disableColumnSelector={false}
      loading={loading}
      getRowId={(row) => keyname ? row[keyname] : row.id}
    />
  );
}